import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import PageTemplate from '../../components/Common/PageTemplate';
import './ResearchLabs.css';

const ResearchLabs = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('biyoloji');
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredLabs, setFilteredLabs] = useState([]);

  const biologyLabs = [
    {
      id: 272,
      name: "Ali Celal Hoş Ichthyology Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/bos.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/ali_celal_hos_ihtiyoloji_laboratuvari-272",
      category: "Ichthyology"
    },
    {
      id: 274,
      name: "Archaeobotany Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_labs_/lab274/Arkeobotanik%20Lab_1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/arkeobotanik_laboratuvari-274",
      category: "Botany"
    },
    {
      id: 275,
      name: "Plant Tissue Culture Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_labs_/lab275/IMG20220617095234.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/bitki_doku_kulturu_laboratuvari-275",
      category: "Botany"
    },
    {
      id: 276,
      name: "Plant Evolution Research Laboratory (PERLab)",
      image: "https://lab.hacettepe.edu.tr/fs_labs_/lab276/lab.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/bitki_evrimi_arastirmalari_laboratuvari_perlab-276",
      category: "Botany"
    },
    {
      id: 283,
      name: "Plant Physiology Research Laboratories",
      image: "https://lab.hacettepe.edu.tr/fs_labs_/lab283/2020-5.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/bitki_fizyolojisi_arastirma_laboratuvarlari-283",
      category: "Botany"
    },
    {
      id: 38,
      name: "Plant Molecular Biology and Plant Biotechnology Research Laboratories (BMBL)",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/bitfiz1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/bitki_molekuler_biyolojisi_ve_bitki_biyoteknolojisi_arastirma_laboratuvarlari_bm-38",
      category: "Botany"
    },
    {
      id: 277,
      name: "Plant Cytogenetics Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_labs_/lab277/sitogenetik%20lab%20resim%201.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/bitki_sitogenetigi_laboratuvari-277",
      category: "Botany"
    },
    {
      id: 39,
      name: "Biogeography Research Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/biyocografya1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/biyocografya_arastirma_laboratuvari-39",
      category: "Biogeography"
    },
    {
      id: 40,
      name: "Biophysics Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/biyofiziklaboratuvari.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/biyofizik_laboratuvari-40",
      category: "Biophysics"
    },
    {
      id: 289,
      name: "Bioinformatics Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_labs_/lab289/bif_1IMG_20220923_165956.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/biyoinformatik_laboratuvari-289",
      category: "Bioinformatics"
    },
    {
      id: 286,
      name: "Biochemistry Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_labs_/lab286/untitled%20folder/WhatsApp%20Image%202022-09-12%20at%2014.52.00.jpeg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/biyokimya_laboratuvari-286",
      category: "Biochemistry"
    },
    {
      id: 41,
      name: "Biocriminal (Forensic) Entomology Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/biyokriminal1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/biyokriminal_adli_entomoloji_laboratuvari-41",
      category: "Entomology"
    },
    {
      id: 278,
      name: "Biomonitoring Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_labs_/lab278/karadeniz%202008%20432.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/biyolojik_izleme_laboratuvari-278",
      category: "Ecology"
    },
    {
      id: 42,
      name: "Environmental Biotechnology Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/cevrebiyoteknolojisi1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/cevre_biyoteknolojisi_laboratuvari-42",
      category: "Biotechnology"
    },
    {
      id: 43,
      name: "Entomology Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/entomoloji.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/entomoloji_laboratuvari-43",
      category: "Entomology"
    },
    {
      id: 44,
      name: "Epithelial Cell Research Group (ECRG)",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/epitelhucrearastirma1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/epitel_hucre_arastirma_grubu_ecrg-44",
      category: "Cell Biology"
    },
    {
      id: 45,
      name: "Evolutionary Ecology Research Laboratories",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/evrimselekoloji1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/evrimsel_ekoloji_arastirma_laboratuvarlari-45",
      category: "Ecology"
    },
    {
      id: 287,
      name: "Evolutionary Microbial Genomics Laboratory (EvoGen)",
      image: "https://lab.hacettepe.edu.tr/fs_labs_/lab287/ScreenShot.png",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/evrimsel_mikrobiyal genomik_laboratuvari_evogen-287",
      category: "Genomics"
    },
    {
      id: 46,
      name: "Functional Ecology Laboratory (FEL)",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/fonksiyonelekoloji1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/fonksiyonel_ekoloji_laboratuvari_fel-46",
      category: "Ecology"
    },
    {
      id: 292,
      name: "Functional and Evolutionary Genetics Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/bos.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/fonksiyonel_ve_evrimsel_genetik_laboratuvari-292",
      category: "Genetics"
    },
    {
      id: 47,
      name: "Genetic Variation and Adaptation Laboratory (GenVA Lab)",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/genvalab1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/genetik_varyasyon_ve_adaptasyon_laboratuvari_genva_lab-47",
      category: "Genetics"
    },
    {
      id: 49,
      name: "Cell Biology Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/hucrebiyolojisi1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/hucre_biyolojisi_laboratuvari_-49",
      category: "Cell Biology"
    },
    {
      id: 50,
      name: "Cell Physiology Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/hucrefizyolojisi1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/hucre_fizyolojisi_laboratuvari-50",
      category: "Cell Biology"
    },
    {
      id: 51,
      name: "Cell Culture Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/hucrekulturu1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/hucre_kulturu_laboratuvari_-51",
      category: "Cell Biology"
    },
    {
      id: 52,
      name: "Tick Research Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/bos.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/kene_arastirmalari_laboratuvari-52",
      category: "Entomology"
    },
    {
      id: 53,
      name: "Molecular Biology Cell Culture Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/molekulerbiyolojihucrekulturu1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/moleküler_biyoloji_hücre_kültürü_laboratuvari-53",
      category: "Molecular Biology"
    },
    {
      id: 54,
      name: "Molecular Plant Systematics Laboratory (MOBİS)",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/bitkilab1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/molekuler_bitki_sistematigi_laboratuvari_mobis_-54",
      category: "Botany"
    },
    {
      id: 288,
      name: "Molecular Cell Biology Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/bos.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/molekuler_hucre_biyolojisi_laboratuvari-288",
      category: "Molecular Biology"
    },
    {
      id: 55,
      name: "Molecular Microbiology Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/molekulermikrobiyoloji1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/molekuler_mikrobiyoloji_laboratuvari-55",
      category: "Microbiology"
    },
    {
      id: 279,
      name: "Molecular Systematic Entomology Laboratory (MOSEL)",
      image: "https://lab.hacettepe.edu.tr/fs_labs_/lab279/MOSEL%20-%20Kopya.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/molekuler_sistematik_entomoloji_laboratuvari_mosel-279",
      category: "Entomology"
    },
    {
      id: 56,
      name: "Molecular Pathology of Rare Diseases Research Group",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/molekulerbiyolojidna1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/nadir_hastaliklarin_molekuler_patolojisi_arastirma_grubu-56",
      category: "Pathology"
    },
    {
      id: 57,
      name: "Palynology Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/palinoloji1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/palinoloji_laboratuvari-57",
      category: "Botany"
    },
    {
      id: 37,
      name: "Palynology and Bee Products Analysis Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_labs_/lab37/palinoloji1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/palinoloji_ve_ari_urunleri_analiz_laboratuvari-37",
      category: "Botany"
    },
    {
      id: 294,
      name: "PAXIS Lab Research Group",
      image: "https://lab.hacettepe.edu.tr/fs_labs_/lab294/paxis1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/paxis_lab_arastirma_grubu-294",
      category: "Research"
    },
    {
      id: 281,
      name: "Protozoology Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/bos.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/protozooloji_laboratuvari-281",
      category: "Microbiology"
    },
    {
      id: 280,
      name: "Water Chemistry Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/bos.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/su_kimyasi_laboratuvari-280",
      category: "Chemistry"
    },
    {
      id: 58,
      name: "Aquatic Life Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/bos.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/sucul_yasam_laboratuvari-58",
      category: "Ecology"
    },
    {
      id: 273,
      name: "Freshwater Fish Biology and Ecology Laboratory (TABBEL)",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/bos.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/tatli_su_baliklari_biyolojisi_ve_ekolojisi_laboratuvari_tabbel-273",
      category: "Ichthyology"
    },
    {
      id: 48,
      name: "Medical and Industrial Biotechnology Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/tibbiveendustriyelbiyoteknoloji1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/tibbi_ve_endustriyel_biyoteknoloji_laboratuvari_-48",
      category: "Biotechnology"
    },
    {
      id: 59,
      name: "Toxicology Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/toksikoloji1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/toksikoloji_laboratuvari-59",
      category: "Toxicology"
    },
    {
      id: 60,
      name: "Applied Entomology Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_labs_/lab60/LOGO.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/uygulamali_entomoloji_laboratuvari-60",
      category: "Entomology"
    },
    {
      id: 61,
      name: "Vector Ecology Research Group Laboratory (VERG)",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/verg1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/vector_ecology_research_group_laboratory_verg-61",
      category: "Ecology"
    }
  ];

  const chemistryLabs = [
    {
      id: 62,
      name: "Inorganic Chemistry Research Laboratory I",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/orgkim3.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/anorganik_kimya_arastirma_laboratuvari_i_-62",
      category: "Inorganic Chemistry"
    },
    {
      id: 63,
      name: "Inorganic Chemistry Research Laboratory II",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/orgkim1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/anorganik_kimya_arastirma_laboratuvari_ii-63",
      category: "Inorganic Chemistry"
    },
    {
      id: 64,
      name: "Inorganic Chemistry Research Laboratory III",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/anorganikkimyalab3-1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/anorganik_kimya_arastirma_laboratuvari_iii-64",
      category: "Inorganic Chemistry"
    },
    {
      id: 66,
      name: "Biosmart",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/biosmart2.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/biosmart-66",
      category: "Biochemistry"
    },
    {
      id: 68,
      name: "Biochromatography and Biodiagnostic Research Group",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/adildenizli1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/biyokromatografi_ve_biyodiyagnostik_arastirma_grubu-68",
      category: "Biochemistry"
    },
    {
      id: 69,
      name: "Electrochemistry Electroanalysis Electrocatalysis Research Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/elekrokimyaelektroanalizelektroktaliz1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/elektrokimya_elektroanaliz_elektrokataliz_arastirma_laboratuvari_-69",
      category: "Electrochemistry"
    },
    {
      id: 70,
      name: "Electrochemistry-Electroactive Polymers and Corrosion Research Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/elektrokimyaelek.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/elektrokimyaelektroaktif_polimerler_ve_korozyon_arastirma_laboratuvari_-70",
      category: "Electrochemistry"
    },
    {
      id: 71,
      name: "Electrochemical Interfaces and Biomaterials Research Group",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/elektrokimyasalarayuzler1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/elektrokimyasal_arayuzeyler_ve_biyomalzemeler_arastirma_grubu-71",
      category: "Electrochemistry"
    },
    {
      id: 72,
      name: "Mass Spectrometry Research Laboratory (SAREG)",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/kutle2.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/kutle_spektrometrisi_arastirma_laboratuvari_sareg-72",
      category: "Analytical Chemistry"
    },
    {
      id: 73,
      name: "Olefin Metathesis Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/olefin1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/olefin_metatez_laboratuvari-73",
      category: "Organic Chemistry"
    },
    {
      id: 74,
      name: "Organic Chemistry Research Laboratory II (ORGSEN)",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/organikkimya1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/organik_kimya_arastirma_laboratuvari_ii_orgsen-74",
      category: "Organic Chemistry"
    },
    {
      id: 67,
      name: "Synthetic Biophysical Systems Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/biyofizkim1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/sentetik_biyofiziksel_sistemler_laboratuvari-67",
      category: "Physical Chemistry"
    },
    {
      id: 75,
      name: "Theoretical Chemistry Research Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/teorikkimya1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/teorik_kimya_arastirma_laboratuvari_-75",
      category: "Theoretical Chemistry"
    }
  ];

  useEffect(() => {
    const labs = activeTab === 'biyoloji' ? biologyLabs : chemistryLabs;
    let filtered = labs;

    // Arama filtresi
    if (searchTerm) {
      filtered = filtered.filter(lab => 
        lab.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        lab.category.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredLabs(filtered);
  }, [activeTab, searchTerm]);

  // Tab değiştiğinde kategori seçimini sıfırla
  useEffect(() => {
    setSearchTerm('');
  }, [activeTab]);

  const currentLabs = activeTab === 'biyoloji' ? biologyLabs : chemistryLabs;

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100
      }
    }
  };

  return (
    <div className="research-labs-page">
      {/* Video Header */}
      <div className="video-header-container">
        <video
          className="video-header"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src="/fenfakultesivideo.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="video-overlay">
          <div className="video-content">
            <motion.h1
              className="video-title"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.5 }}
            >
              {t('pages.researchLabs.pageTitle')}
            </motion.h1>
            <motion.p
              className="video-subtitle"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.8 }}
            >
              {t('pages.researchLabs.pageSubtitle')}
            </motion.p>
          </div>
        </div>
      </div>

      {/* Labs Content Section */}
      <div className="research-labs-container">
        <motion.div 
          className="labs-hero"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="hero-content">
            <h1 className="hero-title">
              <span className="gradient-text">{t('pages.researchLabs.pageTitle')}</span>
            </h1>
            <p className="hero-subtitle">
              {t('pages.researchLabs.heroDescription')}
            </p>
            <div className="hero-stats">
              <div className="stat-item">
                <span className="stat-number">{biologyLabs.length + chemistryLabs.length}+</span>
                <span className="stat-label">{t('pages.researchLabs.activeLabs')}</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">{[...new Set([...biologyLabs.map(lab => lab.category), ...chemistryLabs.map(lab => lab.category)])].length}</span>
                <span className="stat-label">{t('pages.researchLabs.researchFields')}</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">150+</span>
                <span className="stat-label">{t('pages.researchLabs.researchers')}</span>
              </div>
            </div>
          </div>
          <div className="hero-visual">
            <div className="dna-helix"></div>
            <div className="molecules">
              <div className="molecule"></div>
              <div className="molecule"></div>
              <div className="molecule"></div>
              <div className="molecule"></div>
              <div className="molecule"></div>
            </div>
          </div>
        </motion.div>

      </div>

      {/* Content Section with Container */}
      <div className="labs-content-container">
        {/* Controls Section */}
        <motion.div 
          className="labs-controls"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.6 }}
        >
          <div className="tab-buttons">
            <button
              className={`tab-button ${activeTab === 'biyoloji' ? 'active' : ''}`}
              onClick={() => setActiveTab('biyoloji')}
            >
              <span className="tab-icon">🧬</span>
              {t('pages.researchLabs.biologyDept')}
              <span className="tab-count">{biologyLabs.length}</span>
            </button>
            <button
              className={`tab-button ${activeTab === 'kimya' ? 'active' : ''}`}
              onClick={() => setActiveTab('kimya')}
            >
              <span className="tab-icon">⚗️</span>
              {t('pages.researchLabs.chemistryDept')}
              <span className="tab-count">{chemistryLabs.length}</span>
            </button>
          </div>

          <div className="search-container">
            <input
              type="text"
              placeholder={t('pages.researchLabs.searchPlaceholder')}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
            <div className="search-icon">🔍</div>
          </div>
        </motion.div>

        {/* Labs Grid */}
        <motion.div 
          className="labs-grid"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {filteredLabs.map((lab, index) => (
            <motion.div
              key={lab.id}
              className="lab-card"
              variants={itemVariants}
              whileHover={{ 
                y: -10,
                boxShadow: "0 20px 40px rgba(0,0,0,0.1)"
              }}
              whileTap={{ scale: 0.98 }}
            >
              <div 
                className="lab-image-container clickable"
                onClick={() => window.open(lab.link, '_blank')}
              >
                <img 
                  src={lab.image} 
                  alt={lab.name}
                  className="lab-image"
                  onError={(e) => {
                    e.target.src = '/fenfakultesilogo.png';
                  }}
                />
                <div className="lab-overlay">
                  <span className="lab-category">{lab.category}</span>
                  <div className="lab-id">#{lab.id}</div>
                  <div className="click-hint">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>
              </div>
              
              <div className="lab-content">
                <h3 className="lab-title">{lab.name}</h3>
                <div className="lab-footer">
                  <span className="lab-faculty">{t('pages.researchLabs.facultyOfScience')}</span>
                  <a
                    href={lab.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="lab-link"
                  >
                    <span>{t('pages.researchLabs.details')}</span>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </a>
                </div>
              </div>
              
              <div className="lab-glow"></div>
            </motion.div>
          ))}
        </motion.div>

        {filteredLabs.length === 0 && searchTerm && (
          <motion.div
            className="no-results"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <div className="no-results-icon">🔬</div>
            <h3>{t('pages.researchLabs.noLabFound')}</h3>
            <p>{t('pages.researchLabs.noResults', { searchTerm })}</p>
          </motion.div>
        )}

        {/* Research Impact Section */}
        <motion.div
          className="research-impact"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2>{t('pages.researchLabs.researchImpact')}</h2>
          <div className="impact-grid">
            <div className="impact-item">
              <div className="impact-icon">📊</div>
              <h4>{t('pages.researchLabs.publications')}</h4>
              <p>{t('pages.researchLabs.publicationsDesc')}</p>
            </div>
            <div className="impact-item">
              <div className="impact-icon">🏆</div>
              <h4>{t('pages.researchLabs.awards')}</h4>
              <p>{t('pages.researchLabs.awardsDesc')}</p>
            </div>
            <div className="impact-item">
              <div className="impact-icon">🤝</div>
              <h4>{t('pages.researchLabs.collaborations')}</h4>
              <p>{t('pages.researchLabs.collaborationsDesc')}</p>
            </div>
            <div className="impact-item">
              <div className="impact-icon">💡</div>
              <h4>{t('pages.researchLabs.innovation')}</h4>
              <p>{t('pages.researchLabs.innovationDesc')}</p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default ResearchLabs; 